import React from 'react';

// Homepage Magazine Images
import Interviews from './assets/img/magazine-cover-interviews.jpg';
import InspirationMachine from './assets/img/magazine-cover-inspiration-machine.jpg';

// Artwork for Page Backgrounds
import AboutArtwork from './components/PageArtwork/AboutArtwork';
import StepsArtwork from './components/PageArtwork/StepsArtwork';
import QuestionsArtwork from './components/PageArtwork/QuestionsArtwork';
import ResourcesArtwork from './components/PageArtwork/ResourcesArtwork';
import StrategyArtwork from './components/PageArtwork/StrategyArtwork';

const Config = {
  // Home Magazine Config
  // All other issues are fetched from the WordPress CMS
  home: [
    {
      image: Interviews,
      title: 'Interviews',
      path: '/interviews',
    },
    {
      image: InspirationMachine,
      title: 'Inspiration Machine',
      path: '/inspiration-machine',
    },
  ],

  /*eslint-disable */
  testimonials: [
    {
      quote: 'Community, culture, wisdom, inspiration! This has it all!',
      bg: 'var(--lightPurple)',
      color: 'var(--white)',
    },
    {
      quote: "It's hard to imagine how I functioned before the Show!",
      bg: 'var(--lime)',
      color: 'var(--black)',
    },
    {
      quote: 'It is hard to imagine how I functioned before the Show!',
      bg: 'var(--copper)',
      color: 'var(--white)',
    },
    {
      quote:
        "Before I read this, I was so scared and lost. But now, I'm a Director of Art Directors!",
      bg: 'var(--pureBlue)',
      color: 'var(--white)',
    },
    {
      quote:
        "I'm not an expert, but—wait, yes, now I AM an expert, thanks to the Art Direction Show!",
      bg: 'var(--neonYellow)',
      color: 'var(--black)',
    },
    {
      quote: 'Five stars! Ten out of ten! A+. Dreamy and scary-smart all at once!',
      bg: 'var(--lightPink)',
      color: 'var(--black)',
    },
  ],
  /*eslint-enable */

  // Top Navigation Links Config
  // All other links are fetched from the WordPress CMS
  links: [
    {
      link: '/interviews',
      linkText: `Artist Interviews`,
      themeClass: 'artist',
    },
    {
      link: '/inspiration-machine',
      linkText: `Inspiration Machine`,
      themeClass: 'inspo',
    },
    {
      link: '/design-prompt-generator',
      linkText: `Design Prompt Generator`,
      themeClass: 'prompt',
    },
    {
      link: '/inspiration-nation',
      linkText: `Inspiration Nation: Critic's Corner`,
      themeClass: 'criticsCorner',
    },
    {
      link: '/inspiration-gallery',
      linkText: `Inspiration Nation Gallery`,
      themeClass: 'gallery',
    },
    {
      link: '/issues',
      linkText: '<<<<<<<<<< All Issues <<<<<<<<<<',
      themeClass: 'malibu',
    },
  ],

  inspirationMachine: [
    {
      title: 'Ups Mood',
      slug: 'ups-mood',
      key: 'upsMood',
    },
    {
      title: 'Ups Mood: Artful Blobs',
      slug: 'ups-mood-artful-blobs',
      key: 'upsMoodArtfulBlobs',
    },
    {
      title: 'Ups Mood: Artisanal Grids—Gridmasters',
      slug: 'ups-mood-artisanal-grids-gridmasters',
      key: 'upsMoodGrids',
    },
  ],

  aboutStatement: {
    heading: 'What is This!?',
    text:
      'Have you ever dreamed a dream? Designed a website? Laid out a magazine? Planned a photo shoot? Or even just thought you might do something like that, someday? This site is for you. (Actually, it was originally just for Upstatement, which is why you might see some references to very internal processes here. Just ignore those!) The Art Direction Show is a comprehensive collection of information, tips, behind-the-scenes interviews, and everything to do with commissioning work from artists. Take a stroll through our step-by-step guide to learn about strategy, process, and logistics, then wander over to our extensive Are.na to find endless inspiration. We’re growing all the time, so keep checking back, or send suggestions and questions our way!',
  },

  // Page artwork mapping
  pageArtwork: {
    about: <AboutArtwork />,
    steps: <StepsArtwork />,
    strategy: <StrategyArtwork />,
    questions: <QuestionsArtwork />,
    resources: <ResourcesArtwork />,
  },

  houseAds: {
    headers: ['BTW', 'FYI'],
    descriptions: [
      'Did you know we don\'t just art direct? See our many offerings at <a href="https://upstatement.com" target="_blank" rel="noopener noreferrer">Upstatement</a>',
      'We come from <a href="https://upstatement.com" target="_blank" rel="noopener noreferrer">Upstatement</a>',
      'Design</br>Branding</br>Product</br>Strategy</br><a href="https://upstatement.com" target="_blank" rel="noopener noreferrer">here</a>',
    ],
  },

  promptGenerator: {
    whats: [
      'record album',
      'display ad',
      'name tag',
      'invoice',
      'signup email',
      'set of brand colors',
      'brand guideline',
      'moodboard',
      'coffee table book',
      'postcard',
      'Twitter banner',
      'record cover',
      'Twitch Channel',
      'lapel pin',
      'storefront',
      'business card',
      'stamp',
      'tote bag',
      'pair of socks',
      'poster',
      'screen saver',
      'desktop wallpaper',
      'app icon',
      'set of stickers',
    ],
    whos: [
      'The CIA',
      'America',
      'Facebook',
      'a pastry chef',
      'The Illuminati',
      'Reddit',
      'The Babysitters Club',
      'Greta Thunberg',
      'The Explorers Club',
      'a basketball team',
      'The Humane Society',
      'a farmers market',
      'Sweet Valley High',
      'an architecture firm',
      'a hospital',
      'a bagel shop',
      'a psychiatrist',
      'a journalist',
      'The International Space Station',
      'a transportation start-up',
      'an HBO drama',
      'a private detective',
      'a Netflix comedy',
    ],
    wheres: [
      'Buenos Aires',
      'Boston',
      'London',
      'NYC',
      'Paris',
      'Brisbane',
      'San Francisco',
      'LA',
      'Chicago',
      'rural America',
      'Seattle',
      'Austin',
      'Melbourne',
    ],
    wildCards: [
      'Use lots of blue',
      'Create a screen recording',
      'Use only one hand',
      'No curved lines',
      'No color',
      'Incorporate zig-zags',
    ],
  },
};

export default Config;
